import { Outlet } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import Header from './Header'
import Footer from './Footer'

export default function Layout() {
  const location = useLocation()

  return (
    <div className="min-h-screen bg-surface-elevated flex flex-col">
      <Header />
      <main className="py-8 flex-1">
        <Outlet />
      </main>
      {location.pathname.startsWith('/velo') ? null : <Footer />}
    </div>
  )
}
